<app-customer-account-dialog id="otc-phone-flow">
  <div id="content">
    <div class="overlay otc-flow otcPhoneDailog">
      <div class="overlay-header">
        <h6>Select the country</h6>
        <div class="close-btn">
          <button mat-icon-button mat-dialog-close (click)="closeFilter()">
            <f-icon icon-config='{"iconName": "xmark", "iconType": "light", "iconSize": "s"}'></f-icon>
          </button>
        </div>
      </div>

      <div class="section-divider"></div>
      <div class="overlay-body">
        <div class="container">
          <p> Please select correct country from the list</p>
          <f-intl-tel-input  #telInput  class="tel-input" 
          language="en-US" 
          [defaultCountry]="countryFlag"
          mandatory-country-code="false" required
          (telInputChanged)="onTelInputChange($event)"
          [value]="maskPhoneNumberForDisplay(rootScope.activeCustTab.otcData.selectedPhoneNumber)"
          helper-text =''
          label-text="Country Code">
          </f-intl-tel-input>
          <div class="btn-controls">
            <f-button text="Continue" title="Continue" (click)="continueOnStep2()" type="button" variant="progressive" [ngClass]="{'disableBtn': !countrySelected}" [disabled]="!countrySelected"></f-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-customer-account-dialog>